export const DEMO_EVENTS = [
  { id: 'demo-1', name: 'Prompt injection', agent: 'Prompt Sentinel', from: [37.62, 55.75], to: [8.68, 50.11], location: 'Frankfurt' },
  { id: 'demo-2', name: 'Tool-chain hijack', agent: 'Tool Guardian', from: [116.4, 39.9], to: [72.88, 19.08], location: 'Mumbai' },
  { id: 'demo-3', name: 'Credential extraction', agent: 'Identity Sentinel', from: [-74, 40.71], to: [-0.12, 51.5], location: 'London' },
  { id: 'demo-4', name: 'Agent impersonation', agent: 'Trust Guardian', from: [28.04, -26.2], to: [103.82, 1.35], location: 'Singapore' },
  { id: 'demo-5', name: 'Policy bypass', agent: 'Policy Sentinel', from: [-46.63, -23.55], to: [-77.49, 38.03], location: 'Virginia' },
  { id: 'demo-6', name: 'Untrusted tool call', agent: 'Boundary Guardian', from: [139.69, 35.68], to: [151.21, -33.87], location: 'Sydney' },
];

export const phaseAt = seconds => ['Detected', 'Intercepting', 'Contained'][Math.floor((seconds % 12) / 4)];

export function arcPoints(C, from, to) {
  const geodesic = new C.EllipsoidGeodesic(C.Cartographic.fromDegrees(...from), C.Cartographic.fromDegrees(...to));
  return Array.from({ length: 61 }, (_, i) => {
    const carto = geodesic.interpolateUsingFraction(i / 60);
    carto.height = 20000 + Math.sin(Math.PI * i / 60) * 1400000;
    return C.Cartesian3.fromRadians(carto.longitude, carto.latitude, carto.height);
  });
}